// extracted by mini-css-extract-plugin
export default {"container":"yF-z","disabled":"zF-z","bgBlack":"AF-z","content":"BF-z","countdown":"CF-z","topCaption":"DF-z","topHeading":"EF-z","heading":"FF-z","copy":"GF-z"};